import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RegistrationStatus } from '../models/preregistration-status.model';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/users.service';

@Component({
  selector: 'app-profile',
  imports: [TranslateModule, DatePipe],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileComponent {
  private readonly authService = inject(AuthService);
  private userService = inject(UserService);

  protected currentUser = this.authService.currentUser;
  protected currentRegistration = this.userService.currentRegistration;

  protected getStatusClass(): string {
    const status = this.currentRegistration()!.data?.status;

    return `${status}`;
  }

  protected getUserStatus(): RegistrationStatus | undefined {
    return this.userService.currentRegistration()?.data?.status;
  }

  protected getFursuitAnswer(): string {
    const hasFursuit = this.currentRegistration()!.data?.registrationData?.hasFursuit;
    return hasFursuit ? 'yes' : 'no';
  }

  protected getTshirtAnswer(): string {
    const wantsTshirt = this.currentRegistration()!.data?.registrationData?.wantsTshirt;
    return wantsTshirt ? 'yes' : 'no';
  }

  protected getTshirtAnswerRaw(): boolean | undefined {
    const wantsTshirt = this.currentRegistration()!.data?.registrationData?.wantsTshirt;
    return wantsTshirt;
  }

  protected getTshirtSize(): string {
    return this.currentRegistration()!.data?.registrationData?.tshirtSize || '-';
  }

  protected getStatusText(): string {
    const status = this.currentRegistration()!.data?.status;
    return `features.profile.registrationStatus.status.${status?.toLowerCase()}`;
  }

  protected getBadgeNumber(): string | undefined {
    const badgeId = this.currentRegistration()?.data?.user?.badgeId ?? this.currentUser()?.badgeId ?? '-';
    return String(badgeId);
  }

  protected getLanguage(): string {
    const lang = this.currentUser()?.language;
    return `shared.language.${lang}`;
  }

  protected goToLink(): void {
    const url = this.userService.currentRegistration()?.data?.purchaseUrl;
    window.open(url, '_blank');
  }

  protected goToLinkHotel(): void {
    const url =
      'https://businesstravel.accor.com/es/booking/advanced-search.html?identification.reserverType=SC&identification.reserverId=SCP4535194&identification.reserverContract=IB844ES193';
    window.open(url, '_blank');
  }

  protected getIberiaDiscount(): string {
    return 'IBERCONMADRID2026';
  }
}
